import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { NotifMessageService } from './notifmessage.service';
import { Subject, Observable, of } from 'rxjs';
import { Items } from '../models/items';
import { catchError } from 'rxjs/operators';
import { FuellingProvider } from '../models/fuellingProvider';
import { ConfigurationService } from './configuration.service';

@Injectable({
  providedIn: 'root'
})
export class FuellingproviderService {

  isSaveNeeded: boolean = false;

  constructor(
    private http: HttpClient,
    private configService: ConfigurationService,
    private notifService: NotifMessageService
  ) { }

  saveSubject = new Subject<any[]>();

  searchSubject = new Subject<any[]>();

  fuellingproviderSubjectPager = new Subject<any[]>();

  emitSaveNeeded() {
    this.isSaveNeeded = true;
    this.saveSubject.next([this.isSaveNeeded]);
  }

  emitCriteria(criteria) {
    this.searchSubject.next(criteria);
  }

  emitFuellingproviderPager(fuellingprovider) {
    this.fuellingproviderSubjectPager.next(fuellingprovider);
  }

  // FuellingProviderAccount API  calls

  findByCriteria(criteria, pager, isDeletedIncluded:boolean): Observable<Items<FuellingProvider>> {
    let params = {};
    Object.assign(params, pager, criteria, {includeDeleted:isDeletedIncluded});

    return this.http.get<Items<FuellingProvider>>(this.configService.config.urlAPI.urlFuellingProvider, { params: params }).pipe(catchError(err => {
      console.log("error findByCriteria", err);
      this.notifService.notifyErrorWithDetailFromApi('ERROR_FUELLING_PROVIDER_API', err);
      let emptyList = new Items<FuellingProvider>();
      emptyList.content = [];
      return of(emptyList);
    }));
  }

  getFuellingProviderById(id): Observable<FuellingProvider> {
    console.log("get POS controllerby id");
    return this.http.get<FuellingProvider>(`${this.configService.config.urlAPI.urlFuellingProvider}/${id}`).pipe(catchError(err => {
      console.log("error", err);
      this.notifService.notifyErrorWithDetailFromApi('ERROR_FUELLING_PROVIDER_API', err);
      let emptyItem = new FuellingProvider();
      return of(emptyItem);
    }));
  }


  createFuellingProviderAccount(newFprovider): Observable<FuellingProvider> {
    return this.http.post<FuellingProvider>(this.configService.config.urlAPI.urlFuellingProvider, newFprovider).pipe(catchError(err => {
      console.log("error", err);
      this.notifService.notifyErrorWithDetailFromApi('ERROR_FUELLING_PROVIDER_API', err);
      return of(null);
    }));
  }

  deleteFuellingProviderAccount(id): Observable<FuellingProvider> {
    return this.http.delete<FuellingProvider>(`${this.configService.config.urlAPI.urlFuellingProvider}/${id}`).pipe(catchError(err => {
      console.log("error", err);
      this.notifService.notifyErrorWithDetailFromApi('ERROR_FUELLING_PROVIDER_API', err);
      return of(null);
    }));
  }

  updateFuellingProviderAccount(fprovider): Observable<FuellingProvider> {
    return this.http.put<FuellingProvider>(this.configService.config.urlAPI.urlFuellingProvider, fprovider).pipe(catchError(err => {
      console.log("error", err);
      this.notifService.notifyErrorWithDetailFromApi('ERROR_FUELLING_PROVIDER_API', err);
      return of(null);
    }));
  }
}
